import React from "react";

export const CaretDown = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 13.625L5.66987 8.9375L14.3301 8.9375L10 13.625Z" fill="currentColor" />
        </svg>
    )
}